import { useNavigate } from "react-router-dom";
import { deleteDocumentState } from "../../../../routing/RoutingStates";
import { IDeleteActionProps } from "../DocumentTableInterfaces";
import "../css/DocumentTable.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
export default function DeleteAction({
  document,
  isAdvancedUser,
}: IDeleteActionProps) {
  const navigate = useNavigate();
  const handleNavigationClick = (row: any) => {
    const deleteDocumentState: deleteDocumentState = {
      document,
      isAdvancedUser,
    };
    navigate("DeleteDocument", {
      state: { deleteDocumentState },
    });
  };

  return (
    <Button id={`mainPageKey-delete-${document.documentReference}`}
            title="Delete Document"
            onClick={() => handleNavigationClick(document)}
            className="pointer btn-xs ms-1 btn-light">
      <FontAwesomeIcon icon={faTrash} />
    </Button>
  );
}
